type ArrayOrOne<T> = T | T[];

export function getSingleElement<T>(maybeArray: ArrayOrOne<T>): T {
  if (Array.isArray(maybeArray)) {
    return maybeArray.at(0);
  }

  return maybeArray;
}
